<template>
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="10" vs-sm="12" class="text-left mb-4">
				<vs-input class="w-full" :label="$t('MODULE.SwitchDescription')" v-model="questionsByPage[index].content"/>
			</vs-col>

		</vs-row>
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
				<div class="w-full flex flex-col justify-center items-center">
					<label class="block">{{$t('MODULE.valueDefaultSwitch')}}</label>
					<vs-switch :color="color" v-model="questionsByPage[index].properties.default"/>
				</div>
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
				<Color :index="index"></Color>
			</vs-col>
		</vs-row>

	</div>
</template>

<script type="text/javascript">
	import Color from '../../componentsToQuestions/Color.vue';
	import { mapState } from 'vuex';
	export default {
		props: ['index'],
		components: { Color },
		computed: {
			...mapState('resource',['questionsByPage']),
            /**
             * Obiene el color de la propiedad para el componente.
             */
			color() {
				return this.questionsByPage[this.index].properties.color;
			}
		}
	}
</script>
